var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import { getApiClient } from "../../services/AxiosClients";
const baseURL = "/aviso/tag";
export default class TagService {
    static assignTagsToPerson(personId, tagIds) {
        return FetchService.postSingleResponse(baseURL + "/assignTagsToPerson", {
            personId,
            tagIds,
        });
    }
    static search(query, max = 50, includeSystemTags = false) {
        return FetchService.get(baseURL + "/searchTags", {
            query,
            max,
            includeSystemTags,
        });
    }
    static getTags(search, pageSize = 50) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/tags/search/findByNameContainingIgnoreCase", { params: { search, size: pageSize, sort: "name" } });
            return response.data._embedded.tags;
        });
    }
    static getNonSystemTags(search, pageSize = 50) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/tags/search/findByNameContainingIgnoreCaseAndSystem", { params: { search, system: false, pageSize, sort: "name" } });
            return response.data._embedded.tags;
        });
    }
    static findByIds(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/tags/search/findByIdIn", {
                params: { ids: ids.join(",") },
            });
            return response.data._embedded.tags;
        });
    }
}
